import { memo, useCallback } from 'react';
import { StackNavigationProp, useNavigation } from '@betty/navigation';
import { Box, useLayout } from '@betty/moonlight';
import { JackpotProgressMilestoneProps } from './JackpotProgressMilestone.types';
import { CommunityJackpotNavigatorParamsList } from '../../../../../navigators/CommunityJackpotNavigator.types';
import GoalCard from './GoalCard/GoalCard';
import JackpotCard from './JackpotCard/JackpotCard';
import MeasurementGraph from './MeasurementGraph/MeasurementGraph';

function JackpotProgressMilestone({
  id,
  label,
  status,
  prizes,
  threshold,
  rewardAmount,
  jackpotWinnerStatus,
  jackpotWinnerScreenName,
  goalCardDisabled,
  jackpotCardHighlighted,
}: JackpotProgressMilestoneProps) {
  const navigation =
    useNavigation<StackNavigationProp<CommunityJackpotNavigatorParamsList>>();
  const [goalCardLayout, onGoalCardLayout] = useLayout();
  const [jackpotCardLayout, onJackpotCardLayout] = useLayout();

  const onAllWinnersPress = useCallback(() => {
    navigation.navigate('CommunityJackpotWinnersScreen', {
      milestoneId: id,
    });
  }, [id, navigation]);

  const onAllPrizesPress = useCallback(() => {
    navigation.navigate('CommunityJackpotRewardsScreen', {
      milestoneId: id,
    });
  }, [id, navigation]);

  return (
    <Box flex={1} minHeight={60} flexDirection="row" gap="space-1200">
      <Box flex={1}>
        <GoalCard
          threshold={threshold}
          disabled={goalCardDisabled}
          transform={`translateY(-${goalCardLayout.height / 2}px)`}
          onLayout={onGoalCardLayout}
        />
        <MeasurementGraph alignment="right" />
      </Box>
      <Box flex={1}>
        <JackpotCard
          label={label}
          status={status}
          prizes={prizes}
          highlighted={jackpotCardHighlighted}
          rewardAmount={rewardAmount}
          jackpotWinnerStatus={jackpotWinnerStatus}
          jackpotWinnerScreenName={jackpotWinnerScreenName}
          transform={`translateY(-${jackpotCardLayout.height / 2}px)`}
          onAllWinnersPress={onAllWinnersPress}
          onAllPrizesPress={onAllPrizesPress}
          onLayout={onJackpotCardLayout}
        />
        <MeasurementGraph alignment="left" />
      </Box>
    </Box>
  );
}

export default memo(JackpotProgressMilestone);
